<template>
  <RevTooltip>
    <template #trigger="{ show, hide }">
      <IconInfo
        :aria-label="label"
        :class="['relative inline', iconClass]"
        size="16"
        @focusin="show"
        @focusout="hide"
        @mouseleave="hide"
        @mouseover="show"
      />
    </template>
    <slot />
  </RevTooltip>
</template>

<script lang="ts" setup>
import { RevTooltip } from '@ds/components/Tooltip'
import { IconInfo } from '@ds/icons/IconInfo'

defineProps<{
  label: string
  iconClass: string
}>()
</script>
